import { combineReducers } from 'redux'
import { billReducer } from './bill.reducer';
import { branchReducer } from './branch.reducer';
import { consumerReducer } from './consumer.reducer';
import { userReducer } from './user.reducer';

export default combineReducers({
    consumers: consumerReducer,
    bills: billReducer,
    branches: branchReducer,
    users: userReducer
});
